import { render, staticRenderFns } from "./Tema4.vue?vue&type=template&id=e15d9b9a&lang=pug"
import script from "./Tema4.vue?vue&type=script&lang=js"
export * from "./Tema4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports